<template>
  <el-dialog
    :visible.sync="visible"
    custom-class="no-header"
    @close="clearData"
    width="520px"
  >
    <!--    <div class="close" @click="closeDialog"><i class="el-icon-close"></i></div>-->

    <div class="login">
      <img
        v-if="loginType === 'code'"
        class="switch-button"
        src="@/assets/imgs/front/icon_web_btn.svg"
        @click="switchLoginType('pc')"
      />
      <img
        v-if="loginType === 'pc'"
        class="switch-button"
        src="@/assets/imgs/front/icon_scancode_btn.svg"
        @click="switchLoginType('code')"
      />
      <template v-if="!offsiteTest">
        <el-tabs
          v-model="activeName"
          v-show="loginType === 'pc'"
          @tab-click="tabClick"
        >
          <el-tab-pane label="手机号登录" name="phoneLogin">
            <div class="container">
              <div style="margin-top: 48px">
                <span class="error" v-if="!mobileValid && mobileFocus"
                  >请输入正确的手机号！</span
                >
                <el-input
                  v-model="user.mobile"
                  @focus="mobileFocus = true"
                  :class="{ validError: !mobileValid && mobileFocus }"
                  @input="checkMobile"
                  prefix-icon="el-icon-mobile-phone"
                  placeholder="请输入手机号"
                />
              </div>
              <div
                v-if="
                  activeName === 'phoneLogin' &&
                  loginType !== 'code' &&
                  !offsiteTest
                "
                id="captcha-element"
              ></div>
              <!-- <NoCaptcha  @slideCallback="finishSlide" :reload="reload" v-if="activeName==='phoneLogin'&&loginType!=='code'&&!offsiteTest"/> -->
              <VerificationCode
                v-model="user.code"
                v-if="loginType === 'pc'"
                type="login"
                :mobile="user.mobile"
                :check-flag="validFlag && mobileValid"
              />
              <div class="to-register" @click="goToRegister">新用户注册</div>
              <div
                id="captcha-button"
                class="button"
                :class="{ disabled: !submitValid }"
                @click="login('code')"
              >
                立即登录
              </div>
              <p class="agreement">
                登录即视为同意 <span @click="openAgreement">《用户协议》</span>
              </p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="密码登录" name="passwordLogin">
            <div class="container">
              <div style="margin-top: 48px">
                <span class="error" v-if="!mobileValid && mobileFocus"
                  >请输入正确的手机号！</span
                >
                <el-input
                  prefix-icon="el-icon-mobile-phone"
                  @focus="mobileFocus = true"
                  @input="checkMobile"
                  :class="{ validError: !mobileValid && mobileFocus }"
                  v-model="user.mobile"
                  placeholder="请输入手机号"
                />
              </div>
              <el-input
                prefix-icon="el-icon-lock"
                show-password
                v-model="user.password"
                placeholder="请输入您的密码"
              />
              <div
                v-if="
                  activeName === 'passwordLogin' &&
                  loginType !== 'code' &&
                  !offsiteTest
                "
                id="captcha-element"
              ></div>
              <!-- <NoCaptcha  @slideCallback="finishSlide" :reload="reload" v-if="activeName==='passwordLogin'&&loginType!=='code'&&!offsiteTest"/> -->
              <div class="to-register" @click="goToRegister">新用户注册</div>
              <div
                id="captcha-button"
                class="button"
                :class="{ disabled: !submitValid }"
                @click="login('password')"
              >
                立即登录
              </div>
              <p class="agreement">
                登录即视为同意 <span @click="openAgreement">《用户协议》</span>
              </p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template v-else>
        <div class="offsiteTitle">
          <span>安全验证</span>
        </div>
        <div class="redTip">为了您的账户安全，需要进一步验证</div>
        <div class="container">
          <div style="margin-top: 0px">
            <el-input v-model="offsiteForm.mobile" disabled />
          </div>
          <VerificationCode
            v-model="offsiteForm.code"
            anotherSendApi="offsiteLogin"
            type="offsiteLogin"
            :mobile="offsiteForm.mobileStr"
            :checkFlag="true"
          />
          <div class="to-register" @click="goToRegister">新用户注册</div>
          <div
            class="button"
            style="width: 100%; margin-top: 8px"
            @click.prevent="offsiteSubmit"
          >
            {{ offsiteLoginStatus }}
          </div>
          <p class="agreement">
            登录即视为同意 <span @click="openAgreement">《用户协议》</span>
          </p>
        </div>
      </template>
      <ScannerCodeLogin
        v-if="loginType == 'code'"
        class="container"
        @loginSuccess="loginSuccess"
        @bindMobile="goToRegister"
      />
    </div>
  </el-dialog>
</template>

<script>
import apis from '@/api/apis'
import auth from '@/utils/auth'
// import NoCaptcha from '@/components/front/tool/NoCaptcha.vue'
import VerificationCode from '@/components/front/tool/VerificationCode.vue'
import ScannerCodeLogin from '@/components/front/ScannerCodeLogin.vue'
import crypto from '@/utils/crypto'

export default {
  name: 'frontLogin',
  components: { VerificationCode, ScannerCodeLogin },
  data() {
    return {
      reload: false,
      offsiteLoginStatus: '确 认',
      loading: false,
      offsiteForm: {
        mobile: undefined,
        mobileStr: undefined,
        code: undefined,
      },
      offsiteTest: false,
      mobileFocus: false,
      mobileValid: false, // 手机号验证格式
      loginType: 'pc', // pc:手动输入账户密码，code：扫码
      visible: false,
      noCaptcha: '',
      captcha: null,
      captchaButton: null,
      activeName: 'phoneLogin',
      validFlag: false,
      user: {
        mobile: '',
        password: '',
        code: '',
        captchaVerifyParam: '',
      },
      code: {
        login_id: '',
        qr_url: '',
      },
    }
  },
  computed: {
    submitValid() {
      if (this.activeName === 'phoneLogin') {
        return this.mobileValid && this.user.code && this.validFlag
      } else {
        return this.mobileValid && this.user.password && this.validFlag
      }
    },
  },
  watch: {
    visible:{
      handler(val){
        if (val) {
          this.initCaptcha()
        }
      }
    },
    activeName: {
      immediate: true,
      handler(val) {
        console.log(val);
        this.captchaButton = null
        // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
        document.getElementById('aliyunCaptcha-mask')?.remove()
        document.getElementById('aliyunCaptcha-window-popup')?.remove()
        this.initCaptcha()
      },
    },
  },
  methods: {
    getInstance(instance) {
      console.log('instance', instance)
      this.captcha = instance
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      // const result = await xxxx('http://您的业务请求地址', {
      //     captchaVerifyParam: captchaVerifyParam, // 验证码参数
      //     yourBizParam... // 业务参数
      // });
      // return {
      //  captchaResult: true, // 验证码验证是否通过，boolean类型，必选
      //  bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      // }
      this.user.captchaVerifyParam = captchaVerifyParam
      this.validFlag = true
      return {
        captchaResult: true, // 验证码验证是否通过，boolean类型，必选
        bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      }
    },
    // 验证通过后调用
    onBizResultCallback(e) {
      return e.preventDefault()
    },
    // 弹出验证框，popupId为组件id，用于支持验证通过后继续触发业务逻辑
    popup(popupId) {
      console.log('?????')
      this.popupId = popupId
      this.captchaButton.click()
    },
    initCaptcha() {
      this.captchaButton = document.getElementById('captcha-button')
      window.initAliyunCaptcha({
        SceneId: '2kb9hr8w', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: '1o7686', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        immediate: true,
        slideStyle: {
          width: 368,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      })
    },
    closeDialog() {
      this.visible = false
      this.clearData()
    },
    openAgreement() {
      window.open(
        'http://www.wikeyun.cn/agreement/detail.html?id=343',
        '_blank'
      )
    },
    clearData() {
      this.reload = true
      this.mobileFocus = false
      this.passwordFocus = false
      this.mobileValid = false
      this.validFlag = false
      this.activeName = 'phoneLogin'
      this.user = {
        mobile: '',
        password: '',
        code: '',
        captchaVerifyParam: '',
        // sessionId: undefined, // 滑动验证功能：必填参数，从前端获取，不可更改，android和ios只传这个参数即可
        // slideToken: undefined, // 滑动验证功能：必填参数，从前端获取，不可更改
        // sig: undefined, // 滑动验证功能：必填参数，从前端获取，不可更改
        // scene: 'nc_login', // 滑动验证功能：必填参数，从前端获取，不可更改，登录则传：nc_login，注册则传：nc_register
      }

      this.loginType = ''
    },
    loginSuccess() {
      this.$emit('loginSuccess')
      this.visible = false
    },
    tabClick() {
      this.mobileFocus = false
      this.user = {
        mobile: '',
        password: '',
        code: '',
        captchaVerifyParam: '',
        // sessionId: undefined, // 滑动验证功能：必填参数，从前端获取，不可更改，android和ios只传这个参数即可
        // slideToken: undefined, // 滑动验证功能：必填参数，从前端获取，不可更改
        // sig: undefined, // 滑动验证功能：必填参数，从前端获取，不可更改
        // scene: 'nc_login', // 滑动验证功能：必填参数，从前端获取，不可更改，登录则传：nc_login，注册则传：nc_register
      }
      this.mobileValid = false
      this.validFlag = false
    },
    checkMobile() {
      if (/^1[3456789]\d{9}$/.test(this.user.mobile)) {
        this.mobileValid = true
      } else {
        this.mobileValid = false
      }
    },
    finishSlide(data) {
      this.user.sessionId = data.sessionId
      this.user.slideToken = data.token
      this.user.sig = data.sig
      this.validFlag = true
    },
    // initNC() {
    //   // if (this.activeName === 'passwordLogin') {
    //   //   return
    //   // }
    //   if (this.visible && !this.ncLogin) {
    //     console.log(111111111);
    //     // 实例化nc
    //     // eslint-disable-next-line no-undef
    //     AWSC.use("nc", (state, module) => {
    //       var nc_token = ["FFFF0N0000000000A608", (new Date()).getTime(), Math.random()].join(':');
    //       // 初始化
    //       this.ncLogin = module.init({
    //         // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
    //         appkey: "FFFF0N0000000000A608",
    //         //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
    //         token: nc_token,
    //         trans: {"key1": "code0"},
    //         elementID: ["usernameID"],
    //         is_Opt: 0,
    //         language: "cn",
    //         isEnabled: true,
    //         timeout: 3000,
    //         times: 5,
    //         scene: "nc_login",
    //         // 声明滑动验证需要渲染的目标ID。
    //         renderTo: "ncLogin",
    //         width: '368',
    //         //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
    //         success: (data) => {
    //           // console.log(data,'data');
    //           this.user.sessionId = data.sessionId
    //           this.user.token = data.token
    //           this.user.sig = data.sig
    //           this.validFlag = true
    //         },
    //         // 滑动验证失败时触发该回调参数。
    //         fail: (failCode) => {
    //           window.console && console.log(failCode)
    //         },
    //         // 验证码加载出现异常时触发该回调参数。
    //         error: (errorCode) => {
    //           window.console && console.log(errorCode)
    //         },
    //       })
    //     })
    //   } else if (this.ncLogin) {
    //     console.log(3333333333);
    //     this.ncLogin.reset()
    //   }
    // },
    offsiteSubmit() {
      this.loading = true
      this.loginStatus = '正在登录...'
      apis.login
        .offsiteLogin({
          mobile: this.offsiteForm.mobileStr,
          code: this.offsiteForm.code,
        })
        .then((result) => {
          console.log(result, 'result')
          this.loading = false
          auth.saveSkey(result.data.security_key)
          auth.saveToken(result.data.userinfo.token)
          auth.saveUser(result.data.userinfo)
          this.$emit('loginSuccess')
          this.visible = false
          // this.loginStatus = '登录成功，即将跳转...'
          // setTimeout(() => {
          //   this.$router.push('/control')
          // }, 300)
        })
        .catch(() => {
          this.loginStatus = '确 认'
          this.loading = false
        })
    },
    login(type) {
      if (type === 'code') {
        if (!this.submitValid) {
          return
        }
        apis.login
          .mobileLogin(this.user)
          .then((res) => {
            this.reload = true
            if (res.data) {
              auth.saveUser(res.data.userinfo)
              auth.saveToken(res.data.userinfo.token)
              auth.saveSkey(res.data.security_key)
              this.$emit('loginSuccess')
              this.visible = false
            }
          })
          .catch((err) => {
            console.log(err)
            this.reload = true
          })
          .finally(() => {
            this.reload = false
          })
      }
      if (type === 'password') {
        if (!this.submitValid) {
          return
        }
        const saveform = JSON.parse(JSON.stringify(this.user))
        saveform.password = crypto.encrypt(saveform.password)
        console.log('saveform', saveform)
        apis.login
          .login(saveform)
          .then((res) => {
            this.reload = true
            if (res.data) {
              auth.saveUser(res.data)
              auth.saveToken(res.data.token)
              auth.saveSkey(res.data.security_key)
              this.loginSuccess()
            }
          })
          .catch((err) => {
            console.log(err)
            this.reload = true
            if (err.code === 2) {
              this.offsiteTest = true
              this.offsiteForm.mobile = err.data.mobile
              this.offsiteForm.mobileStr = err.data.mobileStr
            }
          })
          .finally(() => {
            this.reload = false
          })
      }
    },
    showDialog() {
      this.loginType = 'pc'
      this.visible = true
      this.reload = false
    },
    switchLoginType(type) {
      // pc || code
      this.offsiteTest = false
      this.ncLogin = null
      console.log(this.ncLogin)
      this.loginType = type
    },
    goToRegister(loginId, openId) {
      this.$emit('register', loginId, openId)
      this.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
.no-header {
  position: relative;
  .close {
    width: 40px;
    height: 40px;
    position: absolute;
    top: -45px;
    right: -45px;
    font-size: 30px;
    background: #767575a1;
    border-radius: 50%;
    padding: 5px;
    color: #bdbbbb;
    &:hover {
      transform: scale(1.1);
    }
  }

  .el-input.validError {
    ::v-deep.el-input__inner,
    ::v-deep.el-input__inner:focus {
      border-color: red;
    }
  }

  .switch-button {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }

  .login {
    padding: 31px 56px;

    .container {
      width: 368px;

      .expired {
        opacity: 0.5;
      }

      & > div {
        margin-top: 32px;
        position: relative;

        .error {
          font-size: 12px;
          font-weight: 400;
          color: #ff4d4f;
          line-height: 24px;
          position: absolute;
          top: -24px;
          left: 0;
        }
      }

      .to-register {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        color: #0b4ffc;
        line-height: 22px;
        cursor: pointer;
      }

      .button {
        margin-top: 8px;
        width: 368px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #0b4ffc;
        border-radius: 4px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;

        &.disabled {
          opacity: 0.2;
          cursor: not-allowed;
        }
      }

      .agreement {
        font-size: 14px;
        font-weight: 400;
        margin-top: 32px;
        line-height: 22px;
        text-align: center;

        span {
          color: #fc2326;
          cursor: pointer;
        }
      }

      .code {
        width: 240px;
        margin: 48px auto;
        padding: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.1);
      }

      .code-title {
        font-size: 24px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 33px;
        text-align: center;
      }
    }
  }
}

::v-deep.el-tabs__item.is-active {
  color: #1e1e28;
}

::v-deep.nc-container .nc_scale .nc_iconfont {
  box-sizing: content-box;
}
.offsiteTitle {
  text-align: center;
  color: #1e1e28;
  font-weight: bold;
  height: 40px;
  font-size: 18px;
  margin-bottom: 15px;
  span {
    display: inline-block;
    height: 100%;
    border-bottom: 4px solid #000;
  }
}
.redTip {
  color: #ff4d4f;
  margin-top: 62px;
  line-height: 34px;
  margin-bottom: 32px;
}
::v-deep#aliyunCaptcha-sliding-wrapper{
  display: block !important;
}
</style>
